import Icon from '@klv/atoms/icon';
import type { IHeadlineOnly } from '../types';
import * as s from '../styles';

const HeadlineOnly = ({
  backgroundColor,
  headline,
  hoverColor,
  link,
  mainTileHoverColor,
  openInNewTab,
}: IHeadlineOnly) => (
  <s.HOContainer
    $backgroundColor={backgroundColor}
    $hoverColor={hoverColor || mainTileHoverColor}
  >
    <s.TileLink
      aria-label={openInNewTab ? `${headline} (opens in a new tab)` : ''}
      href={link}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <s.ContentContainer>
        {headline && <s.HOHeadline className="h5 Semibold">{headline}</s.HOHeadline>}
        <Icon fillColor="inherit" size={2.4} iconName="ArrowButtonRight" />
      </s.ContentContainer>
    </s.TileLink>
  </s.HOContainer>
);

export default HeadlineOnly;
